<script>

export default {
    name: "Tab",

    emits: [],

    props: {
        className: {
            type : String,
            default: ''
        },
        activeTab: {
            type : String,
            required: false,
            default: 'bobiler',
        },
        name: {
            type : String,
            required: true
        },
        selected: {
            type : Boolean,
            default: false
        }
    },
    
    mounted() {
        // this.setCurrentUrl();
        // let tab = this.getQueryParam('tab');
        //
        // if(tab){
        //     this.isActive = this.id === tab;
        //     console.log(tab);
        //     return;
        // }
        //
        // this.isActive = this.selected;
    },

    data() {
        return {

        };
    },
    
    computed: {
        id() {
            return this.name.toLowerCase().replace(/ /g, '-');
        },

        href() {
            return '#' + this.id;
        },

        isActive() {
            return (this.activeTab === this.id);
        }
    },

    methods: {

    }
    
}

</script>

<template>
    <div
        :class="className" v-show="isActive">
        <slot></slot>
    </div>
</template>